/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';
import { useTranslation } from 'react-i18next';

export default function langsEnum(){
  const { t } = useTranslation();
  const tr = (language) => t(`language.${language}`);
  return new EnumBase([
    { name: tr('ptBR'), id:'pt-BR'},
    { name: tr('en'), id:'en'},
    { name: tr('es'), id:'es' },
  ]);
}
